// @ts-nocheck

import palette from '../palette';

export const LiveBar = {
  backgroundColor: palette.bluegrey850,
};

export const LiveBarItem = {
  labelColor: palette.neutralgrey350,
  default: {
    backgroundColor: palette.bluegrey850,
  },
  selected: {
    backgroundColor: palette.bluegrey750,
  },
};
